import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Translate from '@client/components/shared/translation/Translate';
import { injectIntl } from 'react-intl';

import RadioButton from '@client/components/shared/RadioButton';
import { Button, ButtonType } from '@pegasus/ui-components/components/button';
import { track } from '@client/helpers/tracking';

import { Security } from '../svgIcons/security/Security';
import PaymentInfoBox from './PaymentInfoBox';
import styles from './overlayContent.scss';
import RadioLabel from './RadioLabel';

const OPTION_EDIT_PAYMENT = 'OPTION_EDIT';
const OPTION_PAYED = 'OPTION_PAYED';
const OPTION_CANCEL = 'OPTION_CANCEL';

const OPTIONS = {
    [OPTION_EDIT_PAYMENT]: 'optionEditPayment',
    [OPTION_PAYED]: 'optionPayed',
    [OPTION_CANCEL]: 'optionCancel'
};

export class OverlayContent extends PureComponent {
    static propTypes = {
        showCreditCardSecurityInfo: PropTypes.bool.isRequired,
        onCancelOrder: PropTypes.func.isRequired,
        onChangePayment: PropTypes.func.isRequired,
        onAlreadyPayed: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
    };

    static defaultProps = {
        showCreditCardSecurityInfo: false
    };

    state = {
        selectedOption: null
    };

    handleSubmit = () => {
        switch (this.state.selectedOption) {
            case OPTION_CANCEL:
                this.props.onCancelOrder();
                break;
            case OPTION_PAYED:
                this.props.onAlreadyPayed();
                break;
            case OPTION_EDIT_PAYMENT:
                this.props.onChangePayment();
                break;
            default:
                break;
        }
    };

    onReadMoreClick = () => {
        track('overlay_popup_preliminaryFAQ');
    }

    render() {
        const { selectedOption } = this.state;

        return (
            <div styleName="content-wrapper">
                <div styleName="content">
                    <h2 styleName="content-header">
                        <Translate message="header" />
                    </h2>

                    <div styleName="error-msg">
                        <Translate message="errorMsg" />
                    </div>

                    {this.props.showCreditCardSecurityInfo && (
                        <div>
                            <PaymentInfoBox
                                icon={<Security width="25px" height="25px" />}
                                title={<Translate message="protectedByPSD2" />}
                                content={
                                    <Fragment>
                                        <Translate message="creditCardIdentityConfirmation" />
                                        <a
                                            href={this.props.intl.formatMessage(
                                                { id: 'learnMoreLink' }
                                            )}
                                            target="_blank"
                                            styleName="learn-more"
                                            onClick={this.onReadMoreClick}
                                        >
                                            <Translate message="learnMore" />
                                        </a>
                                    </Fragment>
                                }
                            />
                        </div>
                    )}

                    <div styleName="options-group-title">
                        <Translate message="optionMsg" />:
                    </div>
                    <div styleName="options-group">
                        <div>
                            {Object.keys(OPTIONS).map(option => {
                                const handleOptionSelection = () => {
                                    this.setState({
                                        selectedOption: option
                                    });
                                };

                                const renderLabel = () => (
                                    <RadioLabel label={OPTIONS[option]} />
                                );

                                return (
                                    <div styleName="radio-button-wrapper" key={option}>
                                        <RadioButton
                                            value={
                                                option ===
                                                this.state.selectedOption
                                            }
                                            onClick={handleOptionSelection}
                                            renderLabel={renderLabel}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div styleName="button-wrapper--second-try">
                        <Button
                            buttonType={ButtonType.primary}
                            disabled={!selectedOption}
                            onClick={this.handleSubmit}
                            fullWidth
                        >
                            <Translate message="submitBtn" />
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(
    CSSModules(OverlayContent, styles, { allowMultiple: true })
);
